import { Api } from "../config/request"

const TranslationApi = {
    saveLanguage(data) {
        return Api.post(`/api/translation/v1/set-language`, data)
    }
}

export default TranslationApi